import React from 'react';
import { Card, CardBody, Button, Badge } from 'reactstrap';
import { H5, H6, P } from '../../../../AbstractElements';

const StepCard = ({ step, onEdit, onDelete, onToggleStatus }) => {
  const getTypeBadge = (type) => {
    const badges = {
      quiz: { color: 'primary', icon: 'fa-question-circle', text: 'Quiz' },
      information: { color: 'info', icon: 'fa-info-circle', text: 'Information' },
      verification: { color: 'success', icon: 'fa-check-circle', text: 'Verification' }
    };
    const badge = badges[type] || { color: 'secondary', icon: 'fa-circle', text: type };
    
    return (
      <Badge color={badge.color}>
        <i className={`fa ${badge.icon} me-1`}></i>
        {badge.text}
      </Badge>
    );
  };

  return (
    <Card className="shadow-sm border-0 mb-4">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Badge color="secondary" className="px-2">
                <i className="fa fa-sort-numeric-asc me-1"></i>
                #{step.stepOrder}
              </Badge>
              {getTypeBadge(step.stepType)}
              <Badge color={step.isActive ? 'success' : 'secondary'}>
                {step.isActive ? 'Active' : 'Inactive'}
              </Badge>
              {step.isRequired && (
                <Badge color="danger">
                  <i className="fa fa-star me-1"></i>
                  Required
                </Badge>
              )}
            </div>
            <H5 className="text-dark mb-1">{step.stepName}</H5>
          </div>
          <div className="d-flex gap-2">
            <Button 
              color="outline-primary" 
              size="sm"
              onClick={() => onEdit(step)}
            >
              <i className="fa fa-edit"></i>
            </Button>
            <Button 
              color="outline-danger" 
              size="sm"
              onClick={() => onDelete(step.id)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        </div>

        {step.stepDescription && (
          <P className="text-muted mb-3">{step.stepDescription}</P>
        )}

        {/* Step Config */}
        {step.stepConfig && Object.keys(step.stepConfig).length > 0 && (
          <div className="mb-3 p-3 bg-light rounded">
            <H6 className="mb-2">Configuration:</H6>
            <pre className="mb-0" style={{fontSize: '0.85rem'}}>
              {JSON.stringify(step.stepConfig, null, 2)}
            </pre>
          </div>
        )}

        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            {step.createdAt && `Created: ${new Date(step.createdAt).toLocaleDateString('vi-VN')}`}
          </small>
          <Button
            color={step.isActive ? 'warning' : 'success'}
            size="sm"
            onClick={() => onToggleStatus(step.id)}
          >
            <i className={`fa fa-${step.isActive ? 'eye-slash' : 'eye'} me-1`}></i>
            {step.isActive ? 'Tắt' : 'Bật'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default StepCard;

